// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgba(29, 57, 105, 1)',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif', // Set default font
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: '2rem',
        },
        input: {
          height: '10px',
          padding: '0',
          fontSize: '12px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          background: "rgba(29, 57, 105, 1)",
          color: '#fff',
          textTransform: 'none', // optional: remove uppercase
          '&:hover': {
            background: "rgba(29, 57, 105, 1)",
            color: '#fff',
          },
        },
      },
    },
  },
});

export default theme;
